import React from 'react'
import Logo from '../assets/MALogo.svg'
import '../styles/footer.css'

const Footer = () => {
  return (
    <div>
      {/* Desktop Footer */}
      <div className="d-none d-md-flex justify-content-around align-items-center pt-3" id="footer-container">
        <p>© 2026 Melee Academy</p>
        <img src={Logo} className="footer-logo" style={{marginLeft: '120px'}} alt="Melee Academy Logo" />
        <div className='d-flex justify-content-between footer-anchors' style={{width: "300px"}}>
            {/* Contact, About, Privacy, Terms anchor links */}
            <a style={{textDecoration: "none", color: 'white'}} href="/contact">Contact</a>
            <a style={{textDecoration: "none", color: 'white'}} href="/about">About</a>
            <a style={{textDecoration: "none", color: 'white'}} href="/privacy">Privacy</a>
            <a style={{textDecoration: "none", color: 'white'}} href="/terms">Terms</a>
        </div>
      </div>
      {/* Mobile & Tablet Footer */}
      <div className="d-flex flex-column d-md-none justify-content-around align-items-center gap-2 pt-4" id="footer-container">
        <div className='d-flex align-items-center'>
          <img src={Logo} className="footer-logo" alt="Melee Academy Logo" />
          <h2 className='ms-3' style={{ fontWeight: 600 }}>Melee Academy</h2>
        </div>
        <div className='d-flex justify-content-between footer-anchors' style={{width: "300px"}}>
            {/* Contact, About, Privacy, Terms anchor links */}
            <a style={{textDecoration: "none", color: 'white'}} href="#">Contact</a>
            <a style={{textDecoration: "none", color: 'white'}} href="#">About</a>
            <a style={{textDecoration: "none", color: 'white'}} href="#">Privacy</a>
            <a style={{textDecoration: "none", color: 'white'}} href="#">Terms</a>
        </div>
        <p className='pb-3' style={{color: '#AEAFBA'}}>© 2026 Melee Academy</p>
      </div>
    </div>
  )
}

export default Footer